module.exports = __webpack_public_path__ + "static/media/20240530085307_IMG_7472.0ad6f32e.JPG";